import { datadogRum } from '@datadog/browser-rum';
import { LoginURLState } from 'web-shared/services/sso-auth-service/SSOService';
interface GetRedirectPathOptions {
  withPack?: boolean;
}

// A leading `//` would make the URL protocol-relative and resolve to a foreign origin.
const normalizePath = (path: string) => path.replace(/\/{2,}/g, '/');

export const getRedirectPath = (from?: LoginURLState['from'], { withPack = false }: GetRedirectPathOptions = {}) => {
  if (!from?.pathname) return '/';

  const hasPackPrefix = !!from.pack && (from.pathname === `/${from.pack}` || from.pathname.startsWith(`/${from.pack}/`));

  const packPath = withPack && from.pack && !hasPackPrefix ? `/${from.pack}` : '';
  const search = from.search ?? '';

  const normalizedPathname = normalizePath(`${packPath}${from.pathname}`);
  const resultingPath = `${normalizedPathname}${search}`;
  if (!resultingPath.startsWith('/') || resultingPath.startsWith('//')) return '/';

  try {
    const redirectUrl = new URL(resultingPath, window.location.origin);

    return `${redirectUrl.pathname}${redirectUrl.search}`;
  } catch (_e) {
    datadogRum.addError(new Error('Invalid redirect URL'), {
      pack: from.pack,
      pathname: from.pathname,
      search: from.search,
      normalizedPathname,
      resultingPath,
      origin: window.location.origin,
    });
    return '/';
  }
};